import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { PostMessageTypesEnum } from './app/enums/post-message-types.enum';
import { environment } from './environments/environment';

Sentry.init({
  dsn: environment.SENTRY.DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.httpClientIntegration()
  ],
  tracesSampleRate: 0.1,
  environment: environment.NAME,
  debug: environment.SENTRY.DEBUG
});

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    if (window.parent !== window) {
      window.parent.postMessage(
        { type: PostMessageTypesEnum.IFRAME_READY },
        '*'
      );
    }
  })
  .catch((err) => console.error(err));
